import React, { useState, useEffect } from "react";
import { Box, CssBaseline, Typography } from "@mui/material";
import { Lock } from "@mui/icons-material";
import { useLocation } from "react-router";
import PaymentForm from "../components/payments/PaymentForm";
// import paymentdashboardservice from "../services/paymentdashboardservice";
import DashboardHeaderSection from "../components/common/dashboardheader/DashboardHeader";
import ExpenseLink from "../components/payments/ExpenseLink";
import portalpaymentlink from "../services/portalpaymentlink";

export default function PaymentLink() {
  const location = useLocation();
  const [campaignDetails, setCampaignDetails] = useState(location.state || null);
  const [vendors, setVendors] = useState([]);

  const Init = async () => {
    // let vendors = await paymentdashboardservice.FetchVendors();
    // vendors = vendors.map((obj) => ({
    //   ...obj,
    //   label: `${obj.name} | ${obj.category.name}`,
    // }));
    // setVendors(vendors);

    const response = await portalpaymentlink.getCampaignDetails({
      id: campaignDetails?.id
    });

    setCampaignDetails({
      ...campaignDetails,
      isOfficeExpense: response.isOfficeExpense,
      isFrozen: response.isFrozen,
      frozenBy: response.frozenBy?.fullName
    });
  };

  useEffect(() => {
    Init();
  }, []);

  return (
    <>
      <CssBaseline />
      <DashboardHeaderSection />
      {/* This page is reachable directly (bookmark, back button, a stale tab
          left open from before a freeze) even though the card's own "Create
          Link" icon is already hidden once a campaign is frozen — so this is
          the actual backstop against ever reaching the creation form itself. */}
      {campaignDetails?.isFrozen ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1.5,
            py: 8,
            px: 2,
            textAlign: 'center',
          }}
        >
          <Lock sx={{ fontSize: 40, color: '#F59E0B' }} />
          <Typography variant="h6" fontWeight={700}>
            This campaign is frozen
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Frozen by {campaignDetails.frozenBy || 'a super user'} — contact them to unfreeze it
            before creating a payment link.
          </Typography>
        </Box>
      ) : campaignDetails?.isOfficeExpense ? (
        <ExpenseLink
          campaignDetails={campaignDetails}
        />
      ) : (
        <PaymentForm
          campaignDetails={campaignDetails}
          vendors={vendors}
        />
      )}
    </>
  );
}
